// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".-Ko21 {\n    width: 100%;\n    height: 100%;\n  }\n  .b9Tn8 {\n    width: 100%;\n    height: 100%;\n  }\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"HierarchyQuotaDistribution_gridContainer": "-Ko21",
	"HierarchyQuotaDistribution_advancedGridWrapper": "b9Tn8"
};
export default ___CSS_LOADER_EXPORT___;
